import styled, { css } from 'styled-components';
import { getFontSize, getColorAlias, getSpacing } from '../../utils/index.js';
import { getLinkColor } from './utils.js';

const LinkWrapper = styled.a `
  display: ${({ type }) => (type === 'inline' ? 'inline-block' : 'block')};
  color: ${({ variant }) => variant && getLinkColor(variant)};
  width: fit-content;
  ${({ size }) => size === 'small' ? getFontSize('size14') : getFontSize('size16')};
  font-weight: ${({ bold, theme }) => bold && theme.font.weightBold};
  text-decoration: ${({ underlined }) => (underlined ? 'underline' : 'none')};

  &:hover,
  &:active {
    text-decoration: ${({ underlined }) => (underlined ? 'none' : 'underline')};
  }

  &:focus-within {
    border-color: ${getColorAlias('focus')};
    box-shadow: 0 0 0 2px ${getColorAlias('contentLinkDistinct')};
    border-radius: ${(props) => props.theme.radius.roundedA};
  }

  &:focus-visible {
    outline: none;
  }

  &:visited {
    color: #800080; // TODO: Replace when adding new contentLinkVisitedInverse token

    svg {
      fill: #800080; // TODO: Replace when adding new contentLinkVisitedInverse token
    }
  }
`;
const LinkContent = styled.div `
  display: flex;
  align-items: center;
  flex-direction: ${({ iconModifiers }) => iconModifiers === 'leading' && 'row-reverse'};

  svg {
    fill: ${({ variant }) => variant && getLinkColor(variant)};

    ${({ iconModifiers }) => iconModifiers === 'trailing'
    ? css `
            margin: 0 0 0 ${getSpacing('s01')};
          `
    : css `
            margin: 0 ${getSpacing('s01')} 0 0;
          `}
  }
`;

export { LinkContent, LinkWrapper };
